export type TeamMember = {
  id: "mike-chase" | "fred-potenza" | "ed-strangert" | "christine-bradbury";
  name: string;
  title: string;
  image: string;
  imageAlt: string;
};

export const teamMembers: readonly TeamMember[] = [
  {
    id: "mike-chase",
    name: "Mike Chase",
    title: "CEO / Owner",
    image: "/manus-storage/mike-chase_bbd8aa63.webp",
    imageAlt: "Portrait of Mike Chase, CEO and owner of Partition Stalls",
  },
  {
    id: "fred-potenza",
    name: "Fred Potenza",
    title: "Director of Project Development",
    image: "/manus-storage/fred-potenza_a2f88429.webp",
    imageAlt: "Portrait of Fred Potenza, Director of Project Development at Partition Stalls",
  },
  {
    id: "ed-strangert",
    name: "Ed Strangert",
    title: "Project Manager",
    image: "/manus-storage/ed-strangert_4a983abd.webp",
    imageAlt: "Portrait of Ed Strangert, Project Manager at Partition Stalls",
  },
  {
    id: "christine-bradbury",
    name: "Christine Bradbury",
    title: "Sales Manager",
    image: "/manus-storage/christine-bradbury_2162222d.webp",
    imageAlt: "Portrait of Christine Bradbury, Sales Manager at Partition Stalls",
  },
] as const;

export const companyAbout = {
  heading: "Better commercial restrooms start with a dependable team.",
  paragraphs: [
    "Partition Stalls supplies durable commercial bathroom partitions and restroom accessories with a focus on reliable craftsmanship, thoughtful design, and straightforward project support.",
    "Our team helps customers organize material choices, dimensions, accessories, delivery details, and installation needs so every project can move forward with clarity and professional attention.",
  ],
} as const;
